var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_48)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.000732422C15.5143 0.000732422 20 4.4864 20 10.0001C20 15.5137 15.5143 19.9994 10 19.9994C4.486 19.9994 0 15.5137 0 10.0001C0 4.4864 4.486 0.000732422 10 0.000732422ZM12.7402 6.0769L10 8.81707L7.25983 6.07673C6.93327 5.7501 6.40358 5.74978 6.0767 6.07673C5.75013 6.4033 5.75013 6.93325 6.0767 7.2598L8.81687 10.0003L6.07637 12.7405C5.74973 13.0673 5.74973 13.597 6.07637 13.9236C6.40352 14.2507 6.93288 14.2505 7.25977 13.9239L9.99993 11.1834L12.7401 13.9235C13.0667 14.2501 13.5966 14.2504 13.9232 13.9238C14.2504 13.5966 14.2498 13.067 13.9232 12.7404L11.1831 10.0002L13.9232 7.26005C14.2498 6.93375 14.2504 6.4038 13.9232 6.07692C13.5966 5.75004 13.0667 5.75029 12.7401 6.07692L12.7402 6.0769Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuClose);
export default __webpack_public_path__ + "static/media/icon-menu-close.d956d38f956bd4cd6fa7c8f78a57458b.svg";
export { ForwardRef as ReactComponent };